import { createActions } from 'redux-actions';

export const { setAddWish, clearAddWish } = createActions({
  SET_ADD_WISH: value => value,
  CLEAR_ADD_WISH: () => {}
});



// WEBPACK FOOTER //
// ./src/store/addWish/actions.js